<template>
  <div class="full_layout">
    <div class="order_num text_gray">{{ $t('base.orderNumber') }}:{{list.OrderNo}}</div>
    <div class="deatil_pay_box">
      <div class="paidPay">
        <div>{{OrderStatus[list.Status]}}</div>
      </div>

      <div class="steps_box">
        <div class="greed">
          <div class="dot first">
            <span class="yes weighed"></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="steps_txt first">
            {{ $t('title.weighed') }}<br>{{list.WeightDate|setTimeSS}}
          </div>
        </div>
        <div class="greed">
          <div class="dot">
            <span></span>
            <span></span>
            <span class="yes transit"></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="steps_txt">
            {{ $t('base.unpaid') }}<br>{{list.CreateDate|setTimeSS}}
          </div>
        </div>
        <div :class="list.Status>=2?'greed':''">
          <div class="dot">
            <span></span>
            <span></span>
            <span class="yes shipped"></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="steps_txt" v-if="list.Status>=2">
            {{ $t('base.toBeShipped') }}<br>{{list.PayDate|setTimeSS}}
          </div>
          <div class="steps_txt" v-else>
            {{ $t('base.toBeShipped') }}
          </div>
        </div>
        <div :class="list.Status>=3?'greed':''">
          <div class="dot">
            <span></span>
            <span></span>
            <span class="yes delivery"></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="steps_txt" v-if="list.Status>=3">
            {{ $t('base.shipped') }}<br>{{list.SendDate|setTimeSS}}
          </div>
          <div class="steps_txt" v-else>
            {{ $t('base.shipped') }}
          </div>
        </div>
        <div :class="list.IsReceive?'greed':''">
          <div class="dot">
            <span></span>
            <span></span>
            <span class="yes delivered"></span>
          </div>
          <div class="steps_txt" v-if="list.IsReceive">
            {{ $t('base.completed') }}<br>{{list.ReceiveDate|setTimeSS}}
          </div>
          <div class="steps_txt" v-else>
            {{$t('base.finish')}}
          </div>
        </div>
      </div>
    </div>
    <div class="detail_box">
      <div class="detail_info">
        <div class="detail_info_box">
          <h3>{{$t('base.OrderInformation')}}</h3>
          <template v-if="BuyMemberSource=='US'||list.RealTaxPrice">
            <div>
              <span class="text_gray">{{$t('base.stateTax')}}</span>
              <span>{{setPriceAndWeight(list.RealTaxPrice)}}</span>
            </div>
          </template>
          <div>
            <span class="text_gray">{{$t('base.internationalShippingFee')}}</span>
            <span>{{list.Status==0?$t('base.preparing'):setPriceAndWeight(list.RealPostageMoney)}}</span>
          </div>
          <div>
            <span class="text_gray">{{$t('base.cardhobbyPay')}}</span>
            <span>{{setPriceAndWeight(list.RealPayPostageMoney)}}</span>
          </div>
          <template v-if="list.CouponPrice">
            <div>
              <span class="text_gray">{{ $t('base.coupons') }}</span>
              <span>- {{setPriceAndWeight(list.CouponPrice)}}</span>
            </div>
          </template>
          <div>
            <span class="text_blue">{{$t('base.AmountDue')}}</span>
            <span class="text_blue">{{setPriceAndWeight(list.RealOrderPrice)}}</span>
          </div>
        </div>
        
        <div class="detail_info_box">
          <h3>{{$t('base.PayInfo')}}</h3>
          <div>
            <span class="text_gray">{{$t('colon.paymentMethod')}}</span>
            <span>{{list.PayType}}</span>
          </div>
          <div>
            <span class="text_gray">{{$t('colon.paymentTime')}}</span>
            <span>{{list.PayDate|setTimeSS}}</span>
          </div>
        </div>
        
        <div class="detail_info_box" v-if="list.Address">
          <h3>{{$t('base.buyerInfo')}}</h3>
          <div>
            <span class="text_gray">{{$t('base.name')}}</span>
            <span>{{list.Address.Consignee}}</span>
          </div>
          <div>
            <span class="text_gray">{{$t('colon.phone')}}</span>
            <span>{{list.Address.Mobile}}</span>
          </div>
          <div>
            <span class="text_gray">{{$t('colon.address')}}</span>
            <span>{{address1}},{{address2}},{{list.Address.City}},{{list.Address.Provice}},{{list.Address.ZipCode}}</span>
          </div>
        </div>
      </div>
    </div>
    <template v-if="list&&list.Express">
      <div class="detail_box">
        <div class="detail_info">
          <div class="detail_info_box">
            <h3>{{$t('base.trackingDetails')}}</h3>
          </div>
        </div>
      </div>
      <template v-if="list&&list.Express&&list.SecondExpress">
        <div class="track_tab">
          <div :class="{'on':(step==1)}" @click="GetExpress(list,1)">
            {{$t('base.step1')}}
          </div>
          <div :class="{'on':(step==2)}" @click="GetExpress(list,2)">
            {{$t('base.step2')}}
          </div>
        </div>
      </template>
      <div class="track_box" v-if="list&&list.Express">
        <template v-if="list&&list.Agency.AreaId=='CN'">
          <div class="Virtuousthink">Virtuousthink Trading <a class="text_blue" href="http://track.tcgexp.com/" target="_blank">Logistics Tracking</a></div>
        </template>
        <div class="flex info" v-if="list&&list.Express">
          <div><span class="text_gray">Courier:</span> {{expressName}}</div>
          <div><span class="text_gray">{{$t('base.trackingNumber')}}:</span> {{express}} | <i @click="CopyLink(express)" class="copy text_blue">Copy</i></div>
          <template v-if="list&&list.Agency.AreaId=='CN'">
            <div><span class="text_gray">{{$t('base.ContactUsAt')}}</span> tcgexp@163.com</div>
          </template>
        </div>
      </div>
      <template v-if="expList && expList.Traces&& expList.Traces.length>0">
        <el-scrollbar class="detail_steps" >
          <div class="steps_list" v-for="(item,index) in expList.Traces" :key="index" >
            <div class="steps_list_up">
              <span class="time">{{(setTime(item.AcceptTime))}}</span>
              <span class="dott"></span>
              <span class="add">{{item.Location }}</span> 
            </div>
            <div class="steps_line">{{item.AcceptStation}}</div>
          </div>
        </el-scrollbar>
      </template>
    </template>
    <div class="table_detail_box">
      <div class="table_head">
        <div class="head_box item">{{ $t('base.item') }}</div>
        <div class="head_box itemPrice">{{ $t('base.itemPrice') }}</div>
        <div class="head_box estimatedStateTax">{{$t('base.ForwardingOrderTotal')}}</div>
        <div class="head_box weighed">{{ $t('base.weighed') }}</div>
      </div>
      <div class="history_list_title">
        <div>{{list.CreateDate|setTimeSS}}
            <template v-if="list&&list.OrderDetails">
              <span>{{$tc('base.ItemsTotal',list.OrderDetails.length,{ n: list.OrderDetails.length })}}</span>
            </template>
          </div>
          <template v-if="list&&list.itemPriceTotal">
            <div>
              <span class="text_blue DownloadPurchaseDetails" @click="setPrompt(list._id)">{{$t('base.DownloadPurchaseDetails')}}</span>
            </div>
          </template>
      </div>
      <div class="table_detail ">
        <div class="table_list_detail item">
          <div v-for="(res,i) in list.OrderDetails" :key="i" class="">
            <div class="like_box item">
              <el-image class="like_img" :src="res.TitImg" fit="contain"></el-image>
              <div class="like_detail">
                <p>{{res.Title}}</p>
              </div>
            </div>
            <div class="head_box itemPrice">
              <div>
                {{res.RealLowestPrice?setPriceAndWeight(res.RealLowestPrice):''}}</div>
            </div>
          </div>
        </div>
        <div class="head_box estimatedStateTax">
          <div>{{list.itemPriceTotal?setPriceAndWeight(list.itemPriceTotal):''}}</div>
        </div>
        <div class="head_box weighed">
          <div>{{setPriceAndWeight(list.Weight,'kg')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bus from '@/api/bus';
import { getInfo, getTime,numMulti,numAdd,prompt,formatAmount } from "@/api/public";

export default {
  name: 'tabslist',
  data() {
    return {
      list: '',
      orderId: '',
      address1: '',
      address2: '',
      areaSymbol:this.$store.state.areaSymbol,
      expressName:'',
      express:'',
      step:1,
      expList: '',
      exploading: false,
      userInfo: null,
      OrderStatus: this.$enumInfo.WareOrderStatus
    }
  },
  filters: {
    setTimeSS(val) {
      console.log(val);
      return getTime(val, -8, '', 'cn')
    }
  },
  created() {
    // this.list = window.sessionStorage.getItem('history');
    // this.list = JSON.parse(this.list);orderId
    this.userInfo = getInfo()
    this.orderId = this.$route.params.id
    this.OrdersDetail()
    bus.$emit('headerTitle', 'My Card Hobby');
  },
  mounted() {},
  methods: {
    CopyLink(val) {
      let that = this
      this.$copyText(val).then(function(e) {
        that.isCopy = true
        that.$message({
          message: 'Copy Successfully',
          type: 'success'
        });
      }, function(e) {
        that.isCopy = false
        that.$message.error('Fail');
      })
    },
    setPrompt(orderId){
      try{
        prompt(orderId);
      }catch(e){
        console.log(e)
      }
    },
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    setNumMulti(val,val2){
      let num=0
      num=numMulti(val,val2)
      return num.toFixed(2)
    },
    setPriceAndWeight(val,type){
      let that = this;
      let Unit=type?'kg':that.areaSymbol
      let value=''
      if(val&&val>0){
          value=type?val+Unit:Unit+' '+formatAmount(val)
        }else{
          value=type?that.$t('base.preparing'):'/'
        }
      return value
    },
    // 获取订单详情
    OrdersDetail() {
      let that = this;
      let data = { Id: that.orderId }
      this.$get(this.$interface.GetOrderById, data).then(res => {
        if (res.Result != 0) {
          let result = res.Data
              var itemPriceTotal = 0
              var orderDetails=result.OrderDetails


              let address = result.Address
              let add = address.AddressDetail
              try{
                if (add.indexOf('()') > 0) {
                  add = add.replace(/\(\)/g, "")
                  add = [add]
                } else {
                  if (add.indexOf(')') != -1) {
                    add = add.replace(")", "")
                    add = add.replace("(", "|")
                  }
                  add = add.split("|")
                }
                that.address1=add[0],
                that.address2=add[1]||''
              }catch(e){
                console.log(e)
              }
              
              orderDetails.map(item=>{
                if(item.RealLowestPrice){
                  itemPriceTotal=numAdd(itemPriceTotal,item.RealLowestPrice)
                }else{
                  itemPriceTotal=0
                  return
                }
              })
              result.itemPriceTotal=itemPriceTotal?itemPriceTotal.toFixed(2):0
              //console.log(itemPriceTotal,'itemPriceTotal')
          that.areaSymbol=result.RealOrderPriceUnit;
          that.list = result;
          that.expressName=result.ExpressName
          that.express=result.Express
          //this.GetExpress(result)
          if(result.IsSend){
            this.GetExpress(result)
          }

        }
      })
    },
    // 获取物流信息
    GetExpress(obj,val) {
      let that = this;
      that.exploading = true
      that.expList = '';
      let data = { LogisticCode: obj.Express, ShipperCode: obj.ExpressCode, Mobile: obj.Address.Mobile, OrderCode: obj._id }
      //let data = { LogisticCode:'SF0281281553683', ShipperCode: 'SF', Mobile: obj.Address.Mobile, OrderCode: obj._id }
      if(val){
          that.expressName=obj.ExpressName
          that.express=obj.Express
        that.step=val
        if(val==2){
          that.expressName=obj.SecondExpressName
          that.express=obj.SecondExpress
          //二段物流
          data.LogisticCode=obj.SecondExpress
          data.ShipperCode=obj.SecondExpressCode
        }
      }
      this.$get(this.$interface.GetExpressInfoByShipperCode, data).then(res => {
        if (res.result != 0) {
          if (res.Data == null) {
            that.expList = null
          } else {
            that.expList = res.Data
          }
        } else {
          that.expList = null
        }
        that.exploading = false
        //console.log(res)
      })
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/orderdetail.css";

.dot span{
  border-radius: 50%;
}

.table_detail_box{
  border:none;
}
.table_head{
  height: auto;
  line-height: normal;
  padding:16px 8px;
}
.history_list_title{
  display: flex;
  justify-content: space-between;
  background-color: #f7f7f7;    
  color: #a0a0a0;
  padding: 10px 16px;
  margin-top: 14px;
}
.table_head .item{
  text-align: left;
  padding-left: 100px;
}
.item{
  flex:1
}
.itemPrice{
  width: 195px;
}
.estimatedStateTax{
  width: 180px;
}
.weighed{
  width: 100px;
}
.detail_info{
  width: 100%;
  justify-content: flex-start;
}
.detail_info_box{
  float: left;
  width: auto;
  min-width: 280px;
}
.detail_info_box>div{
  display: flex;
  align-items: center;
}
.detail_info_box>div>span{
  color: #333;
  margin: 0;
}
.detail_info_box>div>span:first-child{    
  width: 110px;
}
.detail_info_box>div>span+span{
  padding-left: 10px;
  flex: 1;
  
}
.detail_info_box>div>.text_gray{
  color: #a0a0a0;
  
}
.detail_info_box>div>.text_blue{
  color: #5F6DAE;
  font-weight: bold;
}
.detail_info_box+.detail_info_box{
  margin-left: 30px;
}




.track_tab{
  display: flex;
  position: relative;
}
.track_tab>div{
  padding:9px 16px;
  border:1px solid #c8c8c8;
  border-radius: 4px 0 0 4px;
  position: relative;
  cursor: pointer;
}
.track_tab>div+div{
  border-radius: 0 4px 4px 0;
  margin-left: -1px;
}
.track_tab>div.on{
  border-color: #5F6DAE;
  background: #E7F0FF;
  color: #5F6DAE;
  z-index: 3;
}

.track_box{    
  line-height: 2;
  margin: 10px 0;
}
.track_box .info{
  align-items: center;
}
.track_box .info>div+div{
  margin-left: 60px;
}

.detail_steps {
  width: 99%;
  height: 270px;
}

.steps_list {
  width: auto;
  position: relative;
}

.steps_list.error {
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 18px;
}

.steps_list_up {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0;
}

.steps_list_up .time {
  width: 160px;
}

.steps_list_up .add {
  flex:1;
  align-items: center;
  word-break: break-all;
    margin-left: 12px;
    font-size: 16px;
}

.steps_list_up .dott {
  width: 24px;
  background: url(../../../static/images/icon/icon_finish_on.svg) no-repeat center;
  min-height: 30px;
  background-size: contain;
  margin-top: 0;
}

.steps_line {
  border-left: 1px solid #a0a0a0;
    padding: 12px 0;
    position: relative;
    bottom: 0;
    min-height: 28px;
    height: auto;
    left: 0;
    line-height: 1.4;
    top: 0;
    margin-left: 171px;
    padding-left: 24px;
}

.steps_list:last-child .steps_line {
  display: none
}

.copy {
  cursor: pointer;
  position: relative;
  padding-left: 18px;
  margin-left: 10px;
}

.copy:before {
  content: '';
  background: url(../../../static/images/icon/icon_copy.svg) no-repeat;
  width: 17px;
  height: 16px;
  position: absolute;
  left: 0;
  top: 0;
}

.Virtuousthink{
  background: url(../../../static/images/icon/icon_laoyang.svg) 0 center no-repeat;
  padding-left: 24px;
}
.Virtuousthink a{
  margin-left: 10px;
}

/deep/ .el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}

/deep/ .is-horizontal {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/waredetail.vue